import React from "react";
import PropTypes from "prop-types";

import { CarouselV3 } from "@lululemon/ufs-shared";
import { renderContentfulComponent } from "@lululemon/cosy-contentful-renderer";
import { baseRenderContentType } from "@lululemon/ui-library";

import StoryBlockText from "./story-block-text";
import WhyYouLoveThisMaterialAndCare from "../why-you-love-this-material-and-care";

import styles from "./story-blocks.module.scss";

function StoryBlocksMobile({
  storyBlocks,
  type,
  materialAndCare,
  doubleLinedText,
  deviceType,
  handleStoryBlocksMobileNavigation
}) {
  const storyBlockElements = storyBlocks?.map(
    ({ fields: { media, title, description, scaleImage }, sys: { id } }) => {
      const isCarousel = media?.length > 1;

      const mediaElements = media?.map((m, i) => {
        const slideProps = isCarousel
          ? {
              role: "group",
              "aria-roledescription": "slide",
              "aria-label": `${i + 1} of ${media.length}`
            }
          : {};
        return (
          <div key={m?.sys?.id} {...slideProps}>
            {renderContentfulComponent({
              contentfulComponent: {
                ...m,
                fields: { ...m?.fields, autoplay: true }
              },
              options: {
                renderContentType: baseRenderContentType,
                transformElement: ({ element, contentType }) => {
                  const extraProps = {};
                  if (contentType === "responsiveImage") {
                    extraProps.draggable = "false";
                  }
                  return React.cloneElement(element, extraProps);
                }
              }
            })}
          </div>
        );
      });
      const headingId = `story-block-${id}-hdg`;
      return (
        <React.Fragment key={id}>
          <div className={styles.mediaBlock}>
            {isCarousel ? (
              <div className={styles.carousel}>
                <CarouselV3
                  ariaLabelledbyId={headingId}
                  cellSpacing={8}
                  frameAriaLabel={`${title} Carousel Slides`}
                  renderBottomCenterControls={false}
                  scrollMode="remainder"
                  slidesToShow={1.15}
                  wrapAround={false}
                  onUserNavigation={() =>
                    handleStoryBlocksMobileNavigation(type)
                  }
                  deviceType={deviceType}
                >
                  {mediaElements}
                </CarouselV3>
              </div>
            ) : (
              mediaElements
            )}
          </div>
          <StoryBlockText
            description={description}
            scaleImage={scaleImage}
            title={title}
            titleId={headingId}
          />
        </React.Fragment>
      );
    }
  );

  return (
    <>
      {storyBlocks && storyBlockElements}
      {(materialAndCare || doubleLinedText) && (
        <WhyYouLoveThisMaterialAndCare
          materialAndCare={materialAndCare}
          doubleLinedText={doubleLinedText}
        />
      )}
    </>
  );
}

StoryBlocksMobile.propTypes = {
  storyBlocks: PropTypes.arrayOf(
    PropTypes.shape({
      fields: PropTypes.shape({
        description: PropTypes.string.isRequired,
        media: PropTypes.arrayOf(
          PropTypes.shape({
            fields: PropTypes.shape({
              description: PropTypes.string,
              imageUrl: PropTypes.string,
              mobileImageUrl: PropTypes.string,
              title: PropTypes.string,
              videoCaptionsUrl: PropTypes.string,
              videoPreviewImageUrl: PropTypes.string,
              videoUrl: PropTypes.string
            }),
            sys: PropTypes.shape({
              contentType: PropTypes.shape({
                sys: PropTypes.shape({
                  id: PropTypes.string
                })
              }),
              id: PropTypes.string
            })
          })
        ),
        scaleImage: PropTypes.shape({
          fields: PropTypes.shape({
            description: PropTypes.string,
            imageUrl: PropTypes.string,
            mobileImageUrl: PropTypes.string
          })
        }),
        title: PropTypes.string.isRequired
      }),
      sys: PropTypes.shape({
        id: PropTypes.string
      })
    })
  ),
  materialAndCare: PropTypes.object,
  doubleLinedText: PropTypes.string,
  deviceType: PropTypes.shape({
    isMobile: PropTypes.bool,
    isTablet: PropTypes.bool,
    isDesktop: PropTypes.bool
  }).isRequired,
  handleStoryBlocksMobileNavigation: PropTypes.func
};

StoryBlocksMobile.defaultProps = {
  storyBlocks: []
};

export default StoryBlocksMobile;
